function onClick(event) {
	var btn = event.currentTarget;
	var container = btn.parentElement.parentElement;
	if (btn.getAttribute('aria-expanded') === 'false') {
		btn.setAttribute('aria-expanded', 'true');
		container.classList.add('--expanded');
	} else {
		btn.setAttribute('aria-expanded', 'false');
		container.classList.remove('--expanded');
	}
}

function ready() {
	window.removeEventListener('load', ready);
	document.addEventListener('DOMContentLoaded', ready);

	document.querySelector('.page-footer__expand-control').addEventListener('click', onClick);
}

if (document.readyState.match(/(completed|interactive)/i)) {
	ready();
} else {
	window.addEventListener('load', ready);
	document.addEventListener('DOMContentLoaded', ready);
}
